import type { SVGProps } from 'react';
const SvgApproval = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#approval_svg__a)">
      <path
        fill="currentColor"
        d="M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2Zm14 2H6v-2h12v2ZM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5Zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4Z"
      />
    </g>
    <defs>
      <clipPath id="approval_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgApproval;
